import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class TransfersService {


	constructor(private http: HttpClient) { }
	url = environment.serverAPI5 + '/' + 'api/transfers';

	url1 = environment.serverAPI1 + "/api";

	searchGINTransfer(query, Page: any, size: any, sort: any): Observable<Object> {
		return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
	}

	getGINTransfer(Page: number, size: number, sort: number): Observable<Object> {
		return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
	}
	getGINTransferById(id: number): Observable<Object> {
		return this.http.get(`${this.url}/${id}`);
	}


	createGINTransfer(Transfer: any): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url}`, Transfer);
	}

	deleteImage(data: any): Observable<Object> {
		return this.http.post(`${this.url}/deleteImage`, data);
	}

	getAllTransferDropDown(): Observable<Object> {
		return this.http.get(`${this.url}/dropdown`);
	}

	deleteByTransferId(transferId: any): Observable<Object> {
		return this.http.delete(`${this.url}/${transferId}`);
	}
	downloadTransferTemplate(): Observable<any> {
		return this.http.get(`${this.url}/template/download`, { responseType: 'arraybuffer', observe: 'response' });
	}
	downloadTransfersReport(Page: number, size: number, sort, selectionTransfers): Observable<any> {
		return this.http.post(`${this.url}/export/page?page=${Page}
		&size=${size}&sort=${sort}`, selectionTransfers, {
			responseType: 'arraybuffer',
			observe: 'response'
		});
	}

}
